import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export default function NextActions({ actions = [] }) {
  if (!actions.length) return null;

  return (
    <div className="glp1-section-block">
      <Text className="glp1-section-title">Next actions</Text>
      <ul className="glp1-action-list">
        {actions.map((action) => (
          <li key={action}>{action}</li>
        ))}
      </ul>
    </div>
  );
}
